export interface Skill {
  color: string
  hoverText?: string
  id?: string
  name: string
  order?: number
  picture?: string
  priority?: boolean
}

interface SkillTagProps {
  skill: Skill
  type?: 'SKILL' | 'PAGE'
}

export const SkillTag = ({ skill }: SkillTagProps) => {
  const { name, color } = skill
  return (
    <div style={{ background: color || '#D7D7D7' }} className="rounded-6 w-fit px-2 py-1">
      <p className="font-TCCCText font-bold text-[#191919] uppercase line-clamp-1 w-max text-[11px]">{name}</p>
    </div>
  )
}
